import { Injectable } from "@angular/core";
import { IdleExpiry } from "@ng-idle/core";

@Injectable({
  providedIn: "root",
})
export class AppIdleExpiryService extends IdleExpiry {
  private lastDate: Date;

  constructor() {
    super();
    this.lastDate = new Date();
  }

  last(value?: Date): Date {
    if (value !== undefined) {
      this.lastDate = value;
    }
    return this.lastDate;
  }
}
